module.exports = __webpack_public_path__ + "img/brown.e66b15e7.svg";